import { Layout } from 'antd';
import styled from 'styled-components';

export const Container = styled(Layout.Header)`
	padding: 0;
	background: #fff;
`;
